import type { DomainEntityConfigModule } from '@web-config-app/core';

import { EN_STRING_ALERT_BANNER_OVERRIDES } from './strings/alert-banner-strings';
import { alertBannerRenderers } from './renderers/severity-renderers';

export const alertBannerConfig: DomainEntityConfigModule = {
  strings: {
    en: EN_STRING_ALERT_BANNER_OVERRIDES,
  },
  entityForm: {
    controlRenderers: alertBannerRenderers,
  },
};
